export default __webpack_public_path__ + "static/media/Saloon PNG.6ada10bf.png";